import { render, staticRenderFns } from "./MyMessage.vue?vue&type=template&id=0e69826b"
import script from "./MyMessage.vue?vue&type=script&lang=ts"
export * from "./MyMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports